/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's opyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

// Global store instance for accessing loading state outside React components
let globalLoadingStore: any = null;

/**
 * getGlobalLoadingStore function.
 * Gets the global loading store instance for use outside React components.
 *
 * @returns {*} Return value description
 */
export const getGlobalLoadingStore = () => {
  return globalLoadingStore;
};

/**
 * setGlobalLoadingStore function.
 * Sets the global loading store instance (called internally by LoadingProvider).
 *
 * @param {*} store - Store instance
 */
export const setGlobalLoadingStore = (store: any) => {
  globalLoadingStore = store;
};

/**
 * addGlobalLoading function.
 * Adds loading state globally (for use outside React components).
 */
export const addGlobalLoading = () => {
  if (globalLoadingStore) {
    const state = globalLoadingStore.getState();
    state.addLoading();
  }
};

/**
 * removeGlobalLoading function.
 * Removes loading state globally (for use outside React components).
 */
export const removeGlobalLoading = () => {
  if (globalLoadingStore) {
    const state = globalLoadingStore.getState();
    state.removeLoading();
  }
};

/**
 * Adds request-level loading globally (for use outside React components).
 */
export const addGlobalRequestLoading = () => {
  if (globalLoadingStore) {
    const state = globalLoadingStore.getState();
    state.addRequestLoading();
  }
};

/**
 * Removes request-level loading globally (for use outside React components).
 */
export const removeGlobalRequestLoading = () => {
  if (globalLoadingStore) {
    const state = globalLoadingStore.getState();
    state.removeRequestLoading();
  }
};
